import { Dispatch, SetStateAction } from "react";
import { KaziModal } from "../../../Shared Components/Kazi/KaziModal"
import { Button, CircularProgress, Typography } from "@mui/material";
import { jobApi, useDeleteJobMutation } from "../../../Redux/api/jobApi";
import { useToast } from "../../../Hooks/useToast";
import { useAppDispatch } from "../../../Redux/store";

interface JobDeletionModalProps {
    open: boolean;
    setOpen: Dispatch<SetStateAction<boolean>>;
    locator: string;
}

export const JobDeletionModal = ({ open, setOpen, locator}: JobDeletionModalProps) => {
    /* ******************** Hooks ******************** */
    const dispatch = useAppDispatch();
    const { showToast } = useToast();
    const [deleteJob, {isLoading: deleteResponseLoading}] = useDeleteJobMutation();
    /* ******************** Variables ******************** */
    /* ******************** Functions ******************** */
    const handleClose = () => {
        setOpen(false);
    }

    const handleDeleteJob = () => {
        deleteJob(locator)
        .unwrap()
        .then(() => {
            dispatch(jobApi.util.invalidateTags(['JobsByStatus']));
            handleClose();
            showToast({
                text: 'Job deleted sucessfully',
                variant: 'success'
            });
        }).catch((err) =>{
            console.log('Error occured while deleting job post: ', err.Error);
            showToast({
                text: 'Unable to delete job post',
                variant: 'error'
            });
        })
    }
    /* ******************** Effects ******************** */
    /* ******************** JSX ******************** */
    return (
        <KaziModal 
            title="Do you want to delete this job post?"
            open={open}
            handleClose={handleClose}
            content={
                <Typography>
                    Once you delete the job post, it will no longer be available. It will not appear in the previous job postings section.
                </Typography>
            }
            actions={[
                <Button onClick={handleClose} variant="outlined">Cancel</Button>,
                <Button 
                    onClick={handleDeleteJob} 
                    variant="contained"
                    endIcon={ deleteResponseLoading ? <CircularProgress color="secondary" size={"18px"}/> :null} 
                >   
                    { deleteResponseLoading ? "Deleting..." : "Delete"}
                    
                </Button>
            ]}
        />
    )
}